import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

/**
 * Interceptor encargado de adjuntar el identificador de sistema (`x-system-identifier`)
 * a todas las peticiones HTTP salientes.
 */
export const systemInterceptor: HttpInterceptorFn = (req, next) => {
  const systemIdentifier = environment.systemIdentifier || 'super-admin';

  const clonedReq = req.clone({
    setHeaders: {
      'x-system-identifier': systemIdentifier,
    },
  });

  return next(clonedReq);
};
